import React from "react";
export default ({ onClick, active, label }) => (
  <button onClick={onClick}>
    <span>{label}</span>
    <svg height="38" width="12">
      <path d="M0,0,L12,19L0,38Z" />
    </svg>
    <style jsx>{`
      button {
        border: none;
        background: transparent;
        margin: 0;
        padding: 0;
        display: flex;
        cursor: pointer;
        min-width: 160px;
      }
      button.active {
        background: #585148;
        color: #fff;
      }
      button:focus {
        outline: none;
      }
      span {
        color: #fff;
        font-family: FrutigerLTCom;
        font-weight: 700;
        font-size: 16px;
        display: block;
        padding: 0 18px;
        line-height: 38px;
        background: #3C8287;
        box-sizing: border-box;
        height: 38px;
        flex-grow: 1;
      }
      svg {
        display: block
      }
      path {
        fill: #3C8287;
      }
    `}</style>
  </button>
);



// WEBPACK FOOTER //
// ./src/components/Quiz/Button.js